import { ButtonBase } from '@mui/material';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';

interface OpenFullImageProps {
	onClick?: () => void;
}

export const OpenFullImage: React.FC<OpenFullImageProps> = ({ onClick }) => (
	<ButtonBase
		sx={{
			position: 'absolute',
			bottom: '18px',
			right: '70px',
			width: '26px',
			height: '26px',
			backgroundColor: '#000000',
			color: '#FFFFFF',
			opacity: '0.7',
			borderRadius: '13px',
		}}
		onClick={onClick}
	>
		<OpenInFullIcon sx={{ width: '14px', height: '14px' }} />
	</ButtonBase>
);
